export default __webpack_public_path__ + "static/media/monte-adentro.4f82b888.svg";